<!-- ═══════════════════════════════════════════════════════════════════════════
     Section: READY FOR THE VOID? — CTA
  ════════════════════════════════════════════════════════════════════════════ -->
<section class="void-cta" aria-labelledby="void-cta-heading">

    <!-- Particle sphere background -->
    <div class="void-cta__sphere" aria-hidden="true">
        <img src="/assets/images/png/cta-sphere.png" alt="cta-logo" loading="lazy" />
    </div>

    <!-- Top divider gradient line -->
    <div class="void-cta__divider" aria-hidden="true"></div>

    <div class="void-cta__container">
        <div class="void-cta__card">

            <h2 class="void-cta__title" id="void-cta-heading">
                <span>{{ 'void_cta.title_1' | translate }}</span>
                <span>{{ 'void_cta.title_2' | translate }}</span>
                <!-- <span class="void-cta__title--gradient">{{ 'void_cta.title_2' | translate }}</span> -->
            </h2>

            <div class="void-cta__actions">
                <!-- <button class="void-cta__btn void-cta__btn--primary" (click)="enterConsole()">
                    <strong>{{ 'void_cta.enter' | translate }}</strong>
                </button>
                <button class="void-cta__btn void-cta__btn--ghost">
                    <strong>{{ 'void_cta.discord' | translate }}</strong>
                </button>
                <button class="void-cta__btn void-cta__btn--ghost">
                    <strong>{{ 'void_cta.roadmap' | translate }}</strong>
                </button> -->
                @for (item of social; track item.text) {
                <a [href]="item.link || '#'" class="void-cta__btn void-cta__btn--ghost" target="_blank" rel="noopener noreferrer" role="listitem" [attr.aria-label]="item.text" (click)="trackExternalLink(item.link, item.text.toLowerCase())">
                    {{ item.text | translate}}
                </a>
                }
            </div>

        </div>
    </div>
</section>